import React, {useState, useRef } from 'react';
import ExportExcel from '../ExportToExcel';
import {Card,OverlayTrigger,Tooltip} from 'react-bootstrap';
import {Table} from 'antd';
import {Input, Button, Space} from 'antd';
import {FilterFilled} from '@ant-design/icons';
import axios from 'axios';
import SuccessImage from '../../../../assets/Images/success.png';
import ErrorImage from '../../../../assets/Images/error.png';
import {services} from '../../../../../url'
import {useSelector} from 'react-redux';

const ServiceInfo = (props:any) => {
    const [datasource, setDatasource] = useState([])
    const searchInput = useRef<any>(null);
    const jwtIdToken = useSelector((state:any) => state.user.token)

    const handleSearch = (selectedKeys:Array<string>, confirm:Function, dataIndex:string) => {
        confirm();
     }
     
     const handleReset = (clearFilters:Function,confirm:Function) => {
        clearFilters();
        confirm();
     };
     
    const getColumnSearchProps = (dataIndex:any) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }:any) => {
        
        return (
          <div style={{ padding: 8 }}>
            <Input
              ref={searchInput}
              value={selectedKeys[0]}
              onChange={e => 
                (e.target.value ? [e.target.value] : [])}
              onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
              style={{ marginBottom: 8, display: 'block' }}
            />
            <Space>
              <Button
                type="primary"
                onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                size="small"
                style={{ width: 90 }}
              >
                Filter
              </Button>
              <Button onClick={() => handleReset(clearFilters,confirm)} size="small" style={{ width: 90 }}>
                Reset
              </Button>
            </Space>
          </div>
        )},
        filterIcon: (filtered:any) => <FilterFilled style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value:any, record:any) =>
          record[dataIndex]
            ? record[dataIndex].toString().toLowerCase() === value.toLowerCase()
            : '',
        onFilterDropdownVisibleChange: (visible:any) => {
          if (visible) {
            setTimeout(() => searchInput?.current.select(), 100);
          }
        },
        render: (text:any) => text
    });
    const sortData = (a:any,b:any) => {
        try {
            if ((a || a >= 0 ) && (b || b >= 0)) {
                if(typeof a === 'string' && typeof b ==='string') {
                    if(a.toLowerCase() > b.toLowerCase()) {return -1}
                    else if(a.toLowerCase() < b.toLowerCase()) {return 1 }
                }
                else {
                    return a-b;
                }
            }
            return 0;

        } catch (error) {
            console.log(error)
        }
     }
    const columns = [
        {
            title: 'Timestamp',
            dataIndex: 'timestamp',
            sorter: (a:any,b:any) => sortData(a.timestamp,b.timestamp),
            ...getColumnSearchProps('timestamp'),
            width: 100
        },
        {
            title: 'Health',
            dataIndex: 'health',
            width: 70,
            align: 'center',
            render: (value:any) => {
                return <>
                        {
                            value.toLowerCase() === "active-active" ?
                            <img src={SuccessImage} className='statusImg' alt='Success'/>:
                            <img src={ErrorImage} className='statusImg' alt='error'/>
                        }
                    </>
            }
        },
        {
            title: 'Route 53',
            dataIndex: 'configured',
            width: 90,
            align: 'center',
            render: (value:any) => {
                return <>
                        {
                            value === "" ? "NA": value==="true"?
                            <img src={SuccessImage} className='statusImg' alt='Success'/>:
                            <img src={ErrorImage} className='statusImg' alt='error'/>
                        }
                    </>
            }
        },
    ];
    const getDataSource = async (collapse:Boolean,region:String,serviceId:any) => {
        if(!collapse) {
            try {
                let url = `${services}?name=${serviceId}&region=${region}`
                const response = await axios.get(url,{
                    headers: {
                        'Authorization': jwtIdToken
                    }
                })
                if(response.status === 200){
                    setDatasource(response.data[serviceId])
                }
            }
            catch(error:any) {
                console.log(error.message)
            }
        }
    }
    const errorMesssage = (item:any) => {
        let error = props.item.dependency.length ? `The following dependencies are failing at the moment :${props.item.dependency.join(',')}` :
                    'Service Error';
         return error
    }
    return <Card>
    <Card.Header>
        {
            props.item.collapse ? <span className='fa fa-angle-down arrowIcon me-2' 
            onClick={() => {props.toggleAccordion(props.index); getDataSource(props.item.collapse,props.region,props.item.serviceId)}}></span> :
            <span className='fa fa-angle-up arrowIcon me-2' onClick={() => {props.toggleAccordion(props.index);}}></span>
        }
        <div className='appService'>{props.item.app ? props.item.app.toUpperCase() : "NA"}</div>
        <div className='serviceName'><a href={props.item.link} target='_blank' rel="noreferrer"
            title={props.item.name ? props.item.name.toUpperCase() : "NA"}>{props.item.serviceId ?
             props.item.name.toUpperCase() : "NA"}</a></div>
        <div className='timestamp' title={props.item.timestamp ? props.item.timestamp.toUpperCase() : "NA"}>
            {props.item.timestamp ? props.item.timestamp.toUpperCase() : "NA"}</div>
        <div className='status'>
            {
                props.item.health === "" ? "NA" :
                    (props.item.health).toLowerCase() === ('Active-Active').toLowerCase() ?
                        <img src={SuccessImage} className='mainStatusImg' alt='Success' /> :
                        <OverlayTrigger
                            placement="bottom"
                            overlay={<Tooltip id={`errror-tooltip-${props.index}`}>{errorMesssage(props.item)}</Tooltip>}
                        >
                            <img src={ErrorImage} className='mainStatusImg' alt='error' />
                        </OverlayTrigger>

            }
        </div>
        <div className='status'>
            {
                props.item.configured=== "true" ?
                    <img src={SuccessImage} className='mainStatusImg' alt='Success' /> : (props.item.configured === "false" ?
                    <img src={ErrorImage} className='mainStatusImg' alt='error' /> : "NA")

            }
        </div>
    </Card.Header>
    {
        !props.item.collapse ?
            <Card.Body>
                <div className='clearfix mb-2'>
                    <div className='float-start'>
                        <OverlayTrigger
                            placement="bottom"
                            overlay={<Tooltip id={`button-tooltip-${props.index}`}>{props.item.description}</Tooltip>}
                        >
                            <span className='fa fa-info-circle infoIcon'></span>
                        </OverlayTrigger>
                        <a style={{textDecoration: 'none'}} href='/' onClick={(e: any) => { e.preventDefault(); props.excelData(props.item.serviceId, props.region); }}>Status History <span className='fa fa-download'></span></a>
                        {
                            props.showExcel ?
                               <ExportExcel excelResponse={props.excelResponse}/> : null
                        }
                    </div>

                </div>
                {
                    
                    datasource.length ?
                        <Table dataSource={datasource} columns={columns as any} showSorterTooltip={false} pagination={false}
                        scroll={{ y: 200 }}  rowKey='timestamp' />
                        : <span>No Data Available</span>
                }
    
                
            </Card.Body> : null
    }
</Card>

}

export default ServiceInfo